import { createFileRoute } from "@tanstack/react-router";
import { UseCasePage } from "@/components/blocks/use-cases/UseCasePage";
import { buildUseCaseHead, loadPageLocale } from "@/lib/page-seo";

export const Route = createFileRoute("/{-$locale}/cas-usage/maintenance-cvc")({
	component: () => <UseCasePage useCase="hvac" />,
	loader: loadPageLocale,
	head: ({ loaderData }) =>
		loaderData ? buildUseCaseHead("hvac", loaderData.locale) : {},
});
